import { Copy, Download, FileText } from 'lucide-react'

interface HeaderActionsProps {
    content: string
    fileName: string
    onCopy?: () => void
    onDownload?: () => void
    onViewRaw?: () => void
}

export function HeaderActions({
    content,
    fileName,
    onCopy,
    onDownload,
    onViewRaw
}: HeaderActionsProps) {
    const handleCopy = () => {
        navigator.clipboard.writeText(content)
        if (onCopy) onCopy()
    }

    const handleDownload = () => {
        const blob = new Blob([content], { type: 'text/markdown' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = fileName || 'file.md'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
        if (onDownload) onDownload()
    }

    const handleViewRaw = () => {
        const newWindow = window.open('', '_blank')
        if (newWindow) {
            newWindow.document.write(`
                <html>
                    <head>
                        <title>${fileName} - Raw</title>
                        <style>
                            body {
                                font-family: monospace;
                                padding: 20px;
                                background: #1e1e1e;
                                color: #d4d4d4;
                                white-space: pre-wrap;
                                word-wrap: break-word;
                            }
                        </style>
                    </head>
                    <body>${content.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</body>
                </html>
            `)
            newWindow.document.close()
        }
        if (onViewRaw) onViewRaw()
    }

    return (
        <div className="flex items-center gap-2">
            <button
                onClick={handleViewRaw}
                className="hidden sm:flex items-center gap-2 px-3 py-1.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-md transition-colors"
                title="View Raw"
            >
                <FileText size={16} />
                <span className="hidden md:inline">Raw</span>
            </button>
            <button
                onClick={handleCopy}
                className="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-md transition-colors"
                title="Copy Content"
            >
                <Copy size={16} />
                <span className="hidden md:inline">Copy</span>
            </button>
            <button
                onClick={handleDownload}
                className="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-md transition-colors"
                title="Download"
            >
                <Download size={16} />
                <span className="hidden md:inline">Download</span>
            </button>
        </div>
    )
}
